import PopUpNotification from '@advanza/interfaces/PopUpNotification'
import { TableCell, TableRow } from '@advanza/shadcn-ui/src/components/ui/table'
import { flexRender, Row } from '@tanstack/react-table'
import PopUpNotificationEntity from 'components/popUpNotifications/PopUpNotificationEntity'

interface Props {
    row: Row<PopUpNotification>
    toggledRowId: number | false
    onSaveRow: (updatedRow: PopUpNotification) => void
    toggleRowSelection: () => void
}

const PopUpNotificationsDataTableRow = ({
    row,
    toggledRowId,
    onSaveRow,
    toggleRowSelection,
}: Props) => {
    const rowId = row.original.pop_up_notification_id || row.original.id || Date.now()
    const isExpanded = toggledRowId === rowId

    return (
        <>
            <TableRow
                data-state={isExpanded ? 'selected' : undefined}
                className="odd:bg-muted"
                onClick={toggleRowSelection}>
                {row.getVisibleCells().map((cell) => (
                    <TableCell key={`cell-${cell.id}`}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </TableCell>
                ))}
            </TableRow>

            {isExpanded && (
                <TableRow className="odd:bg-neutral-100 dark:odd:bg-neutral-800">
                    <TableCell colSpan={row.getVisibleCells().length}>
                        <div className="p-2 text-muted-foreground">
                            <PopUpNotificationEntity data={row.original} setTableRow={onSaveRow} />
                        </div>
                    </TableCell>
                </TableRow>
            )}
        </>
    )
}
export default PopUpNotificationsDataTableRow
